import { join } from 'node:path';
import { rm, rename } from 'node:fs/promises';
import type {
  NewPage,
  RenamedPage,
  PageId,
} from '@wix/ambassador-velo-apps-v1-app/types';
import { pathExists, outputFile } from '@wix/cli-fs';

export async function createPages(
  projectFolder: string,
  pages: NewPage[]
): Promise<void> {
  await Promise.all(
    pages.map((page) => {
      if (!page.pageId?.path || !page.content) {
        return Promise.resolve();
      }

      return outputFile(join(projectFolder, page.pageId.path), page.content);
    })
  );
}

export async function renamePages(
  projectFolder: string,
  pages: RenamedPage[]
): Promise<void> {
  await Promise.all(
    pages.map(async (page) => {
      if (!page.sourcePath?.path || !page.targetPath?.path) {
        return;
      }

      const sourcePath = join(projectFolder, page.sourcePath.path);
      const targetPath = join(projectFolder, page.targetPath.path);

      if (await pathExists(targetPath)) {
        return rm(sourcePath, { force: true });
      }

      return rename(sourcePath, targetPath);
    })
  );
}

export async function deletePages(
  projectFolder: string,
  pages: PageId[]
): Promise<void> {
  await Promise.all(
    pages.map((page) => {
      if (!page.path) {
        return Promise.resolve();
      }

      return rm(join(projectFolder, page.path), { force: true });
    })
  );
}
